var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-padded",attrs:{"id":"domain-dashboard"}},[_c('div',{staticClass:"has-text-centered"},[_c('div',{staticStyle:{"font-size":"40px","margin":"20% 0"}},[_vm._v(" Coming Soon! ")])])])
}]

export { render, staticRenderFns }